import {
  Mutation, MutationAction, Action, VuexModule, getModule, Module,
} from 'vuex-module-decorators';
import store from '../index';
import { SystemService } from '../../api/system-service';

// ステート インターフェース
export interface IPdfState {
  file: string;
}

@Module({
  dynamic: true, store, name: 'auth', namespaced: true,
})
class PdfState extends VuexModule implements IPdfState {
    // state
    file: string = '';

    // mutation
    @Mutation
    SET_FILE(file: string): void {
      this.file = file;
    }

    @Action
    async download() {
      // const blob = await SystemService.getPdf();
      // const url = URL.createObjectURL(blob);
      const url = encodeURIComponent(SystemService.getPdfUrl());
      console.log('download', url);
      this.SET_FILE(url);
    }
}

export const pdfState: PdfState = getModule(PdfState);
